import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ConditionModel from 'tio-data/models/condition';
import type RouterService from '@ember/routing/router-service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export interface UserSettings {
  security: {
    timeout: number;
    passwordMinLength: number;
  };
  register: {
    showCountdown: boolean;
    isEmailRegisterAllowed: boolean;
    isPayrollIdAndLastNameAllowed: boolean;
  };
  customTerms: ConditionModel[];
}

export interface RegisterUser {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  code: string;
  enrolled: boolean;
  inviteExpired?: boolean;
  settings: UserSettings;
  familyInvite: boolean;
}

export default class EnrollRoute extends Route {
  @service declare router: RouterService;
  @service declare store: StoreService;

  queryParams = {
    inviteCode: { refreshModel: true, replace: true },
    code: { refreshModel: true, replace: true },
    email: { refreshModel: false },
  };

  async model(): Promise<RegisterUser | null> {
    const query = location.search;
    const params = new URLSearchParams(query);
    const inviteCode = params.get('inviteCode');

    try {
      const adapter = this.store.adapterFor('invite');
      // @ts-expect-error - Ember Data adapter method not typed on MinimumAdapterInterface
      return await adapter.getInviteByCode(inviteCode);
    } catch (error) {
      console.error('Error fetching invite:', error);
      return null;
    }
  }
}
